import IconLoader from "@/features/Common/components/IconLoader";
import { defaultFullscreenPageStyling } from "@/theme";
import { convertPxToRem } from "@/utils";
import { Stack, Typography } from "@mui/material";
import { detect } from "detect-browser";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function PaymentRedirect() {
  const { t } = useTranslation();
  const device = detect();
  const deviceOsNormalised =
    device?.os?.toUpperCase().split(" ").join("_") || "";

  useEffect(() => {
    if (deviceOsNormalised === "IOS") {
      window?.open("", "_self")?.close();
    }
    window.close();
  });

  return (
    <Stack
      spacing={5}
      justifyContent="center"
      minHeight="100vh"
      sx={{ ...defaultFullscreenPageStyling }}
    >
      <Stack alignItems="center" spacing={2}>
        <IconLoader
          color="primary"
          icon="TrolleyWithFaceIcon"
          sx={{ fontSize: convertPxToRem(110) }}
        />
        <Typography variant="h1" textAlign="center">
          {t("PathologyPaymentRedirect.title")}
        </Typography>
        <Typography variant="body1" textAlign="center" color="neutral.main">
          {t("PathologyPaymentRedirect.subtitle")}
        </Typography>
      </Stack>
    </Stack>
  );
}
